import React from 'react';
import PropTypes from 'prop-types';

const MainContentContainer = ({ children }) => (
  <div className="app-main-content-new">
    {children}
  </div>
);

MainContentContainer.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};

export default MainContentContainer;



// WEBPACK FOOTER //
// ./library/app/components/Global/Containers/MainContentContainer.js